/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Meeting BaaS API
 * Meeting BaaS API
 * OpenAPI spec version: 1.1
 */

/**
 * Fields with value `"simple"` parse as `Kind::Simple`. Fields with value `"fancy"` parse as `Kind::SoFancy`.
 */
export type Provider = (typeof Provider)[keyof typeof Provider]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Provider = {
  Google: "Google",
  Microsoft: "Microsoft"
} as const
